import { useState } from "react";
import PdfViewer from "./PdfViewer";
import css from "./App.module.css";

const pdfOptions = [
  { label: "test.pdf", value: "./test.pdf" },
  { label: "test2.pdf", value: "./test2.pdf" },
  { label: "test3.pdf", value: "./test3.pdf" },
  { label: "test4.pdf", value: "./test4.pdf" },
  { label: "test5.pdf", value: "./test5.pdf" },
  { label: "test6.pdf", value: "./test6.pdf" },
];

function App() {
  const [pdfUrl, setPdfUrl] = useState(pdfOptions[pdfOptions.length - 1].value);

  return (
    <div className={css.app}>
      <h1>PDF.js Demo</h1>

      <select value={pdfUrl} onChange={(e) => setPdfUrl(e.target.value)}>
        {pdfOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>

      <div className={css.container}>
        <PdfViewer pdfUrl={pdfUrl} />
      </div>
    </div>
  );
}

export default App;
